/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Deletefailed1Inputs */

const zh_sidebar_deletefailed1 = /** @type {(inputs: Sidebar_Deletefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除失败`)
};

const en_sidebar_deletefailed1 = /** @type {(inputs: Sidebar_Deletefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete failed`)
};

const es_sidebar_deletefailed1 = /** @type {(inputs: Sidebar_Deletefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar`)
};

/**
* | output |
* | --- |
* | "Delete failed" |
*
* @param {Sidebar_Deletefailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_deletefailed1 = /** @type {((inputs?: Sidebar_Deletefailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Deletefailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_deletefailed1(inputs)
	if (locale === "en") return en_sidebar_deletefailed1(inputs)
	return es_sidebar_deletefailed1(inputs)
});
export { sidebar_deletefailed1 as "sidebar_deleteFailed" }